import { inject } from '@angular/core';

import { MyaccountProductService } from './myaccount-product.service';
import { PortalProductBootstrapper } from './portal-unicode-bootstrapper';

/**
 * Route guard for initializing myaccount-app bootstrap services in Host-App.
 */

export const myaccountProductDeactivateGuard = () => {
    inject(MyaccountProductService).deactivateMyaccount();
};

export const myaccountProductActivateGuard = () => {
    inject(MyaccountProductService).activateMyaccount();

    return inject(PortalProductBootstrapper).onAppInit();
};
